import { IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import "../styles/popup.scss";

export const Popup = ({ children, show, onClose,  ...restProps }) => {
    return show
        ? (
            <div className="popup__background">
                <div className="popup" {...restProps}>
                    {children}
                    <IconButton className="popup__close" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </div>
        )
        : null
}